export const VENDOR = 'Vendor (1p)'
export const SELLER = 'Seller (3p)'
export const HYBRID = 'Hybrid'
